import React from 'react'
import useSelector from 'hooks/use-selector'
import getSelectedIndexMediaGallerySelect from 'modules/media-gallery/redux/selectors/get-selected-index'
import getSelectedColorOptionProductSelect from 'modules/variant/redux/selectors/get-selected-color-option'
import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import useDispatch from 'hooks/use-dispatch'
import updateQuickShopHistorySelectedMediaAction from 'containers/QuickShopProductSidebar/HandleHistoryMediaIndexUpdate/actions/update-quick-shop-history-selected-media'

const QuickShopHandleHistoryMediaIndexUpdate = () => {
  const dispatch = useDispatch()
  const selectedMediaIndex = useSelector(getSelectedIndexMediaGallerySelect)
  const selectedColorOption = useSelector(getSelectedColorOptionProductSelect)
  const selectedColorVariantId = useSelector(getSelectedColorVariantIdVariantSelect)

  const handleUpdate = () => {
    dispatch(
      updateQuickShopHistorySelectedMediaAction()
    )
  }

  React.useEffect(() => {
    handleUpdate()
  }, [
    selectedMediaIndex,
    selectedColorOption,
    selectedColorVariantId
  ])
}

export default QuickShopHandleHistoryMediaIndexUpdate
